import getTemplateThumbnail from '../../api/getTemplateThumbnail';

export const createThumbnailsSlice = (set, get) => ({
	// Define the initial state for thumbnails
	thumbnails: {
		Template: {},
	},
	thumbnailPromises: {}, // Cache for ongoing thumbnail requests

	// Define actions
	getThumbnail: ({ id, __config }) => {
		const { thumbnails, thumbnailPromises } = get();

		// Check if the thumbnail is already cached
		const cachedThumbnail = thumbnails.Template?.[id];
		if (cachedThumbnail) {
			return; // Do nothing if already cached
		}

		// Check if there's an ongoing request for the same thumbnail
		if (thumbnailPromises[id]) {
			return; // Do nothing if a request is already in progress
		}

		// Create a new request and store it in the Promise cache
		const thumbnailPromise = getTemplateThumbnail({ __config, id })
			.then(response => {
				const blob = URL.createObjectURL(response);

				// Update the state with the new thumbnail
				set(() => {
					const currentState = get();
					return {
						thumbnails: {
							Template: {
								...currentState.thumbnails.Template,
								[id]: blob,
							},
						},
						thumbnailPromises: {
							...currentState.thumbnailPromises,
							[id]: undefined, // Remove resolved promise
						},
					};
				});
			})
			.catch(() => {
				// Remove the failed promise from the cache
				set(() => {
					const currentState = get();
					return {
						thumbnailPromises: {
							...currentState.thumbnailPromises,
							[id]: undefined,
						},
					};
				});
			});

		// Store the promise in the cache
		set(() => {
			const currentState = get();
			return {
				thumbnailPromises: {
					...currentState.thumbnailPromises,
					[id]: thumbnailPromise,
				},
			};
		});
	},

	updateThumbnailCache: ({ id, __config }) => {
		const { thumbnails, thumbnailPromises, getThumbnail } = get();
		const updatedTemplate = { ...thumbnails.Template };
		delete updatedTemplate[id];

		const updatedPromises = { ...thumbnailPromises };
		delete updatedPromises[id];

		set(() => ({
			thumbnails: {
				Template: updatedTemplate,
			},
			thumbnailPromises: updatedPromises,
		}));
		getThumbnail({ id, __config });
		console.log('Thumbnail cache and promises removed for id:', id, updatedTemplate);
	},

	resetThumbnailsStore: () => {
		set(() => ({
			thumbnails: {
				Template: {},
			},
			thumbnailPromises: {}, // Clear the Promise cache
		}));
	},
});
